import React,{useState,useEffect} from 'react'
import NotFinishedPic from '../../Utilities/notFinished.gif'
import NotFinishedWav from '../../Utilities/notFinished.wav'
import BGMusic from '../../Utilities/BGMusic.mp3'
import First from '../../Utilities/default.jpg'
import BG1 from '../../Utilities/BG1.jpg'
import BG2 from '../../Utilities/BG2.jpg'
import BG3 from '../../Utilities/BG3.jpg'
import BG4 from '../../Utilities/BG4.jpg'
import BG5 from '../../Utilities/BG5.jpg'
import BG6 from '../../Utilities/BG6.png'
import BG7 from '../../Utilities/BG7.jpg'

const Content=()=>{
    const [currentCount,setCount] = useState(0)
    const [src,setSrc] = useState(`url(${First})`)
    const [textOne, setTextOne] = useState(null)
    const [textTwo, setTextTwo] = useState(null)
    const [textColor, setTextColor] = useState(null)
    const [subtitle, setSubtitle] = useState('青島東路中心招牌')

    const BGstyle = {
        width:'100%',
        height:'700px',
        backgroundImage: src,
        backgroundPosition:'center',
        backgroundRepeat:'no-repeat',
        backgroundSize:'cover',
        transitionDuration:"3s",
        transitionProperty:"background-image"
    }

    const TextOneStyle = {
        position: "absolute",
        opacity:textOne? "1":"0",
        color:textColor,
        width: "800px",
        top: "200px",
        left: "300px",
        fontSize: "60px",
        fontFamily: "Microsoft JhengHei",
        transitionDuration:"2s",
        transitionProperty:"opacity, color",
    }

    const TextTwoStyle = {
        position: "absolute",
        opacity:textTwo?"1":"0",
        color:textColor,
        width: "800px",
        top: "300px",
        left: "600px",
        fontSize: "70px",
        fontFamily: "Microsoft JhengHei",
        transitionDuration:"2s",
        transitionProperty:"opacity, color"
    }

    const SubtitleStyle = {
        padding:"5px",
        borderRadius:"5px 0px 0px 0px",
        position: "absolute",
        width: "500px",
        bottom: "200px",
        right: "180px",
        color:"white",
        backgroundColor:"burlywood",
        fontSize: "30px",
        fontFamily: "Microsoft JhengHei",
    }
    
    //const timer=()=>{
    //    setCount(currentCount + 1)
    //}
    const frameArray = [
        {
            currentCount:2,
            src:`url(${First})`,
            text1:'電影，',
            text2:null,
            textColor:"black",
            subtitle:'青島東路中心招牌'
        },
        {
            currentCount:6,
            src:`url(${First})`,
            text1:'電影，',
            text2: '是我們的開始',
            textColor:"white",
            subtitle:'青島東路中心招牌'
        },
        {
            currentCount:13,
            src:`url(${First})`,
            text1:null,
            text2: '是我們的開始',
            textColor:"white",
            subtitle:'青島東路中心招牌'
        },
        {
            currentCount:17,
            src:`url(${BG1})`,
            text1:'是我們的使命',
            text2:null,
            textColor:"white",
            subtitle:'樹林片庫膠片庫房'
        },
        {
            currentCount:23,
            src:`url(${BG2})`,
            text1:null,
            text2:null,
            textColor:"white",
            subtitle:'典藏組同仁清點庫房膠片'
        },
        {
            currentCount:27,
            src:`url(${BG2})`,
            text1:'保存，',
            text2:null,
            textColor:"white",
            subtitle:'典藏組同仁清點庫房膠片'
        },
        {
            currentCount:31,
            src:`url(${BG2})`,
            text1:'保存，',
            text2:'是我們的專業',
            textColor:"white",
            subtitle:'典藏組同仁清點庫房膠片'
        },
        {
            currentCount:37,
            src:`url(${BG2})`,
            text1:null,
            text2:'是我們的專業',
            textColor:"white",
            subtitle:'典藏組同仁清點庫房膠片'
        },
        {
            currentCount:43,
            src:`url(${BG3})`,
            text1:'推廣，',
            text2:null,
            textColor:"black",
            subtitle:'青島東路中心二樓TIDF辦公室'
        },
        {
            currentCount:50,
            src:`url(${BG3})`,
            text1:'推廣，',
            text2:'因為台灣電影值得，',
            textColor:"white",
            subtitle:'青島東路中心二樓TIDF辦公室'
        },
        {
            currentCount:57,
            src:`url(${BG3})`,
            text1:null,
            text2:'因為台灣電影值得，',
            textColor:"grey",
            subtitle:'青島東路中心二樓TIDF辦公室'
        },
        {
            currentCount:63,
            src:`url(${BG4})`,
            text1:'我們兢兢業業，',
            text2:null,
            textColor:"white",
            subtitle:'修復組同仁正整飭膠片'
        },
        {
            currentCount:70,
            src:`url(${BG4})`,
            text1:null,
            text2:null,
            textColor:"white",
            subtitle:'修復組同仁正整飭膠片'
        },
        {
            currentCount:76,
            src:`url(${BG5})`,
            text1:'我們念茲在茲，',
            text2:null,
            textColor:"black",
            subtitle:'青島東路中心七樓推廣組研究組辦公室'
        },
        {
            currentCount:82,
            src:`url(${BG5})`,
            text1:null,
            text2:null,
            textColor:"black",
            subtitle:'青島東路中心七樓推廣組研究組辦公室'
        },
        {
            currentCount:89,
            src:`url(${BG6})`,
            text1:'坦白說 我們愛死這份工作!',
            text2:null,
            textColor:"white",
            subtitle:'修復組同仁正進行數位化掃描'
        },
        {
            currentCount:95,
            src:`url(${BG6})`,
            text1:null,
            text2:null,
            textColor:"white",
            subtitle:'修復組同仁正進行數位化掃描'
        },
        {
            currentCount:101,
            src:`url(${BG7})`,
            text1:'是的 ',
            text2:null,
            textColor:"black",
            subtitle:'國家電影及視聽文化中心新落成大樓'
        },
        {
            currentCount:106,
            src:`url(${BG7})`,
            text1:'是的 ',
            text2:'我們將繼續前進',
            textColor:"black",
            subtitle:'國家電影及視聽文化中心新落成大樓'
        },
        {
            currentCount:111,
            src:`url(${BG7})`,
            text1:null,
            text2:'我們將繼續前進',
            textColor:"black",
            subtitle:'國家電影及視聽文化中心新落成大樓'
        },
        {
            currentCount:118,
            src:`url(${BG7})`,
            text1:'請期待功能開發完成',
            text2:null,
            textColor:"black",
            subtitle:'國家電影及視聽文化中心新落成大樓'
        },
    ]
    useEffect(
        ()=>{
            if(currentCount > 125)
            {
                return
            }
            else
            {
                frameArray.forEach(frame=>{
                    if(currentCount === frame.currentCount)
                    {
                        setSrc(frame.src)
                        setTextOne(frame.text1)
                        setTextTwo(frame.text2)
                        setTextColor(frame.textColor)
                        setSubtitle(frame.subtitle)
                    }
                })
            }
            const timerFunction = setInterval(setCount(currentCount + 1),1000)
            return ()=>clearInterval(timerFunction)
        },[currentCount,frameArray]
    )
    return < div style={BGstyle}>
               <div style={TextOneStyle}>
                   {textOne}
               </div>
               <div style={TextTwoStyle}>
                   {textTwo}
               </div>
               <div style={SubtitleStyle}>
                   {subtitle}
               </div>
               <audio style={{display:"none"}} type="audio/mp3" src={BGMusic} controls autoPlay loop/>
            </div>
}

export default function NotFinishedPage(props) {
    
    
    
    const BGstyle = {
        width:'100%',
        height:'700px',
        backgroundImage: `url(${NotFinishedPic})`,
        backgroundPosition:'center',
        backgroundRepeat:'no-repeat'
    }

    const TextStyle = {
        position: "relative",
        width: "300px",
        top: "100px",
        left: "400px",
        fontSize: "41px",
        fontFamily: "Microsoft JhengHei"
    }
   
    return (
        <div>
            {props.type === 1 ?
                <div style={BGstyle}>
                    <div style={TextStyle}>
                        功能開發中...
                    </div>
                    <audio style={{display:"none"}} type="audio/mp3" src={NotFinishedWav} controls autoPlay loop/>
                </div>
                :
                <Content/>
            }
        </div>
    )
}